var render = function (_h,_vm) {var _c=_vm._c;return _c('el-col',_vm._b({class:_vm.data.staticClass || '',style:(_vm.data.staticStyle || '')},'el-col',_vm.data.attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }